import React from 'react';
import { IconProps } from '../../icons/types';

const AvailabilityTrackerIcon: React.FC<IconProps> = props => {
  const {
    fillColor = 'var(--bg-primary)',
    width = 24,
    height = 24,
    strokeColor = 'var(--bg-primary)'
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2646 10.3027C12.2805 10.3027 13.916 8.6672 13.916 6.65135C13.916 4.6355 12.2805 3 10.2646 3C8.24878 3 6.61328 4.6355 6.61328 6.65135C6.61328 8.6672 8.24878 10.3027 10.2646 10.3027Z"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M11.2214 19.7586H3.2C3.08954 19.7586 2.99972 19.6685 3.00271 19.558C3.10889 15.6378 6.31904 12.4844 10.2647 12.4844C10.9303 12.4844 11.5769 12.57 12.1854 12.7411"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.5399 20.9983C18.9924 20.9983 20.9805 19.0102 20.9805 16.5578C20.9805 14.1053 18.9924 12.1172 16.5399 12.1172C14.0875 12.1172 12.0994 14.1053 12.0994 16.5578C12.0994 19.0102 14.0875 20.9983 16.5399 20.9983Z"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.3033 14.4297L16.2563 16.8732C16.2557 16.9014 16.2699 16.9279 16.2937 16.9432L18.0886 18.0958"
        stroke={strokeColor}
        strokeWidth="0.9"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default AvailabilityTrackerIcon;
